module.exports = __webpack_public_path__ + "img/pc_p2_guanxian.d042aa98.png";